import React from "react";
import { useHistory } from "react-router-dom";
import { Panel, PanelBody } from "../components/panel/panel.jsx";
import { Api } from "../app-controller.js";
import { useAuth } from "../components/content/auth.jsx";
import { Modal, ModalHeader, ModalBody } from "reactstrap";
import { TabContent, TabPane, Nav, NavItem, NavLink } from "reactstrap";
import classnames from "classnames";
import Swal from "sweetalert2";

import ModalSolicitud from "../components/PrecertificadoCE/ModalSolicitudPrecertificadoCE.jsx";
import ModalSolicitudAutorizacion from "../components/PrecertificadoCE/ModalSolicitudAutorizacionMedico";

class Precertificados extends React.Component {
  initialState = {
    accionCombo: Api.loadCatalogue("cat_accion"),
    estatusTramiteCombo: Api.loadCatalogue("cat_estatus_tramite"),
    nivelUsuario: localStorage.nivel_actual,
    orden: {},
    openModal: false,
    solicitud_id: "",
    folio_solicitud: "",
    solicitud: {},
    registros_pce: 0,
    working: false,
    allDocs: false,
    allSolDocs: false,
    solicitudDocsCheck: [],
    previa: false,
    previa_url: "",
    observaciones_pce: "",
    leyenda: "",
    documentos: [],
    disable_rechazado: false,
    collapse: [
      {
        id: 1,
        collapse: true,
      },
      {
        id: 2,
        collapse: false,
      },
      {
        id: 3,
        collapse: false,
      },
    ],
    activeTab: "1",
    registros_ada: 0,

    busqueda:{},
    buscarAutorizacionDA: {},
    openModalAutorizacion: false,
    solicitud_ada: {},
    no_marchamo: "",
    lista_marchamos: [],
    tramite_id: "",
  };

  constructor(props) {
    super(props);

    this.handlesolicitudDocumentoStatus =
      this.handlesolicitudDocumentoStatus.bind(this);
    this.handlePrecertificadoCEStatus =
      this.handlePrecertificadoCEStatus.bind(this);
    this.handleObservacionChange = this.handleObservacionChange.bind(this);
    this.handleChangeStatusPCE = this.handleChangeStatusPCE.bind(this);
    this.handleSolicitudChecks = this.handleSolicitudChecks.bind(this);
    this.handleDownloadZipPCE = this.handleDownloadZipPCE.bind(this);
    this.handleLeyendaChange = this.handleLeyendaChange.bind(this);
    this.handlePreviaClose = this.handlePreviaClose.bind(this);
    this.handleOpenModal = this.handleOpenModal.bind(this);
    this.handlePrevia = this.handlePrevia.bind(this);
    this.handleBtnPCE = this.handleBtnPCE.bind(this);
    this.resetStates = this.resetStates.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.allDocsSol = this.allDocsSol.bind(this);
    this.toggleCollapse = this.toggleCollapse.bind(this);

    this.closeModalAutorizacion = this.closeModalAutorizacion.bind(this);
    this.handleOpenModalAutorizacion =
      this.handleOpenModalAutorizacion.bind(this);
    this.handleAutorizacionStatus = this.handleAutorizacionStatus.bind(this);
    this.handleChangeStatusADA = this.handleChangeStatusADA.bind(this);

    this.addMarchamo = this.addMarchamo.bind(this);
    this.handleChangeMarchamo = this.handleChangeMarchamo.bind(this);
    this.removeMarchamo = this.removeMarchamo.bind(this);

    this.state = this.initialState;
  }

  toggleTab(tab) {
    if (this.state.activeTab !== tab) {
      this.setState({ activeTab: tab });
    }
  }

  toggleCollapse(index) {
    var newArray = [];
    for (let collapseObj of this.state.collapse) {
      if (collapseObj.id === index) {
        collapseObj.collapse = !collapseObj.collapse;
      } else {
        collapseObj.collapse = false;
      }
      newArray.push(collapseObj);
    }

    this.setState({ collapse: newArray });
  }

  busqueda = {};
  mi_grid = {};
  bAutorizacion = {};
  autorizaciones = {};
  componentDidMount() {
    // si el usuario no es nivel medico veterinario ipsa redireccionamos a home
    if (this.state.nivelUsuario !== "7") {
      window.location.href = "/";
    }

    let grid = {
      source: "app/getSolicitudesPreCertificadoMV",
      target: "#myGrid",
      tableClass: "table table-striped m-b-0 table-hover",
      rowsPerPage: [5, 10, 25, 50, 100],
      progressText: "Cargando datos",
      rows: {
        folio_solicitud: {
          label: "folio solicitud",
        },
        tipo_subproducto: {
          label: "Tipo subproducto",
        },
        fecha_solicitud: {
          label: "fecha",
          render: (me) => {
            me.innerHTML = me.data.fecha_solicitud
              .split(" ")[0]
              .split("-")
              .reverse()
              .join("-")
              .replaceAll("-", "/");
          },
        },
        usuario_comercializador: {
          label: "Nombre comercializador",
        },
        establecimiento_comercializador: {
          label: "Establecimiento comercializador",
        },
        descripcion: {
          label: "estado",
        },
      },
      buttons: [
        {
          //name: "abrir",
          btnClass: "btn btn-primary",
          iconClass: "fas fa-folder-open",
          btnClick: (data) => {
            this.setState({
              solicitud_id: data.id,
              folio_solicitud: data.folio_solicitud,
            });
            this.handleOpenModal(data);
          },
          render: (me, data) => {},
        },
      ],
    };
    this.mi_grid = Api.grid(grid);

    this.busqueda = Api.form({
      target: "#busqueda",
      elementClass: "form-control",
      elements: [
        {
          input: {
            type: "text",
            name: "folio_solicitud",
            label: "Folio",
            placeHolder: "Ingresa el folio de la solicitud",
            cols: 3,
          },
        },
        {
          select: {
            type: "text",
            name: "accion",
            label: "Solicitud",
            cols: 3,
            render: (me) => {
              me.innerHTML = `<option value="">Seleccione</option>`;
              this.state.accionCombo.forEach((s) => {
                if (s.id === "1" || s.id === "3003")
                  me.innerHTML += `<option value="${s.id}">${s.descripcion}</option>`;
              });
            },
          },
        },
        {
          input: {
            type: "date",
            name: "fecha",
            label: "Fecha desde",
            cols: 3,
            value: "",
          },
        },
        {
          input: {
            type: "date",
            name: "fecha2",
            label: "Fecha hasta",
            cols: 3,
            value: "",
          },
        },
        {
          input: {
            type: "text",
            name: "nombre",
            label: "Nombre",
            cols: 8,
            value: "",
          },
        },
        {
          select: {
            name: "estatus",
            label: "Estado",
            placeHolder: "Estado",
            cols: 2,
            render: (me) => {
              me.innerHTML = `<option value="">Seleccione</option>`;
              this.state.estatusTramiteCombo.forEach((s) => {
                me.innerHTML += `<option value="${s.id}">${s.descripcion}</option>`;
              });
            },
          },
        },
        {
          button: {
            name: "buscar",
            class: "form-control btn-orange",
            icon: "fa fa-search",
            cols: 2,
            text: "Buscar",
            click: (e) => {
              //this.mi_grid.go(1, this.busqueda.data());
              this.setState({ busqueda: this.busqueda.data() });
              let search = this.state.busqueda;

              let src = "";
              for (let param in search) {
                if (search[param] !== "") {
                  src += "&" + param + "=" + search[param];
                }
              }

              this.mi_grid.go(1, src);
            },
          },
        },
      ],
    });

    let autorizacion = {
      source: "app/getSolicitudesAutorizacionMedico",
      target: "#myAtorizacion",
      tableClass: "table table-striped m-b-0 table-hover",
      rowsPerPage: [5, 10, 25, 50, 100],
      progressText: "Cargando datos",
      rows: {
        /* folio: {
          label: "Folio",
        }, */
        folio_solicitud: {
          label: "folio solicitud",
        },
        razon_social: {
          label: "Establecimiento",
        },
        fecha_solicitud: {
          label: "fecha",
          render: (me) => {
            me.innerHTML = me.data.fecha_solicitud
              .split(" ")[0]
              .split("-")
              .reverse()
              .join("-")
              .replaceAll("-", "/");
          },
        },
        estatus: {
          label: "Estado",
        },
      },
      buttons: [
        {
          //name: "abrir",
          btnClass: "btn btn-primary",
          iconClass: "fas fa-folder-open",
          btnClick: (data) => {
            this.setState({
              solicitud_id: data.sol_id,
              folio_solicitud: data.folio_solicitud,
            });
            this.handleOpenModalAutorizacion(data);
          },
          render: (me, data) => {},
        },
      ],
    };
    this.autorizaciones = Api.grid(autorizacion);
    /* BUSQUEDA AUTORIZACION*/
    this.bAutorizacion = Api.form({
      target: "#busquedaAutorizacion",
      nombre: "busquedaAutorizacion",
      elementClass: "form-control",
      elements: [
        {
          input: {
            cols: 4,
            name: "folio_solicitud",
            type: "text",
            label: "Folio",
            placeHolder: "Folio de la solicitud",
          },
        },
        {
          input: {
            cols: 8,
            name: "razon_social",
            type: "text",
            label: "Establecimiento",
            placeHolder: "Establecimiento",
          },
        },
        {
          input: {
            cols: 4,
            name: "fecha",
            type: "date",
            label: "Fecha desde",
          },
        },
        {
          input: {
            cols: 4,
            name: "fecha2",
            type: "date",
            label: "Fecha hasta",
          },
        },
        {
          select: {
            cols: 2,
            name: "estatus",
            label: "Estatus",
            render: (me) => {
              me.innerHTML = `<option value="">Seleccione</option>`;
              this.state.estatusTramiteCombo.forEach((s) => {
                me.innerHTML += `<option value=${s.id}>${s.descripcion}</option>`;
              });
            },
          },
        },
        {
          button: {
            cols: 2,
            name: "buscarAutorizacion",
            label: "",
            text: "Buscar",
            class: "form-control btn-warning ",
            icon: "fas fa-search",
            click: (e) => {
              this.setState({ buscarAutorizacionDA: this.bAutorizacion.data() });
              let search = this.state.buscarAutorizacionDA;

              let src = "";
              for (let param in search) {
                if (search[param] !== "") {
                  src += "&" + param + "=" + search[param];
                }
              }

              this.autorizaciones.go(1, src);
            },
          },
        },
      ],
    });
    /* Termina buscador AUTORIZACION */
  }

  handleOpenModal(data) {
    Api.loading(true);
    Api.fetch(
      "app/getSolicitudPrecertificadoCE",
      { solicitud_id: this.state.solicitud_id },
      "POST"
    ).then((response) => {
      this.setState({
        solicitud: response,
        tramite_id: response.tramite_id,
        documentos: response.documentos,
        lista_marchamos: response.lista_marchamos,
        registros_pce: response.total,
        working: false,
        openModal: true,
      });

      let detalle = document.querySelector("#SolicitudPCE");
      /* let docVistaPrevia = detalle.querySelectorAll(".vista-previa");
      docVistaPrevia.forEach((doc) => {
        doc.addEventListener("click", this.handlePrevia);
      }); */

      let docsCheck = [];
      for (let file in response.documentos) {
        docsCheck[response.documentos[file].id] = false;
        this.setState({ solicitudDocsCheck: docsCheck });
      }

      let checkboxs = detalle.querySelectorAll(".checkbox_pce");
      checkboxs.forEach((doc) => {
        doc.addEventListener("change", this.handleSolicitudChecks);
      });

      //detalle.querySelector("#descarga_docs_pce").addEventListener("click", this.handleDownloadZipPCE);
      this.handleBtnPCE();

      if (
        this.state.solicitud.estatus_tramite_id === "4" ||
        this.state.solicitud.estatus_tramite_id === "5" ||
        this.state.solicitud.estatus_tramite_id === "10"
      ) {
        detalle.querySelector("#rechazar_pce").classList =
          "btn btn-danger blockea";
        detalle.querySelector("#aprobar_pce").classList =
          "btn btn-success blockea";
      } else {
        detalle
          .querySelector("#rechazar_pce")
          .addEventListener("click", this.handlePrecertificadoCEStatus);
        detalle
          .querySelector("#aprobar_pce")
          .addEventListener("click", this.handlePrecertificadoCEStatus);
      }

      Api.loading(false);
    });
  }

  handlePrecertificadoCEStatus(e) {
    //validar que el campo de observacion no este vacio
    let statusString = {
      Aceptar: 5,
      Rechazar: 4,
    };

    let status = statusString[e.target.innerText];
    if (
      (this.state.solicitud.observaciones === null ||
        this.state.solicitud.observaciones === "" ||
        this.state.solicitud.leyenda === null ||
        this.state.solicitud.observaciones === "" ||
        this.state.lista_marchamos.length === 0) &&
      status === 5
    ) {
      Swal.fire({
        title: "Atención",
        icon: "warning",
        text: "Favor de ingresar los campos obligatorios de la solicitud.",
      });
    } else {
      if (status === 5) {
        Swal.fire({
          title: "¿Aceptar solicitud?",
          text: "Ingrese observaciones si existen.",
          input: "textarea",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Aceptar",
          cancelButtonText: "Regresar",
          cancelButtonColor: "Red",
          confirmButtonColor: "#4CD964",
          reverseButtons: true,
        }).then((result) => {
          if (result.isConfirmed) {
            this.handleChangeStatusPCE(e.target.value, result.value);
          }
        });
      } else {
        let razon = "";
        Swal.fire({
          title: "Rechazar solicitud",
          icon: "warning",
          html:
            '<textarea id="swal-input1" placeholder="Ingrese razón del rechazo" class="form' +
            '-control" height="30"></textarea>',
          inputPlaceholder: "Marcar solicitar corrección",
          showCancelButton: true,
          confirmButtonText: "Rechazar",
          cancelButtonText: "Regresar",
          cancelButtonColor: "Red",
          confirmButtonColor: "#4CD964",
          reverseButtons: true,
          preConfirm: (r) => {
            razon = document.querySelector("#swal-input1").value;
            if (razon === "") {
              Swal.showValidationMessage(
                "Es obligatorio ingresar una observación"
              );
            }
          },
        }).then((result) => {
          if (result.isConfirmed) {
            this.handleChangeStatusPCE(e.target.value, razon, result.value);
          }
        });
      }
    }
  }

  handlesolicitudDocumentoStatus(e) {
    e.stopPropagation();
    e.preventDefault();

    let id = e.target.id; //parseInt(id);
    let razonText = "";
    let estatus = 1;
    let subproducto_id = e.target.getAttribute("data-subproducto_id");
    //let solicitud = { ...this.state.solicitud };

    let statusString = {
      Aprobar: 2,
      Rechazar: 3,
    };

    estatus = statusString[e.target.getAttribute("data-name")];

    if (estatus === 3) {
      //Si lo rechazas dime por que...

      Swal.fire({
        title: "Descripción del rechazo",
        input: "textarea",
        inputAttributes: {
          autocapitalize: "off",
        },
        showCancelButton: true,
        confirmButtonText: "Continuar",
        showLoaderOnConfirm: true,
        cancelButtonText: "Regresar",
        reverseButtons: true,
        cancelButtonColor: "Red",
        confirmButtonColor: "#4CD964",
        preConfirm: (razon) => {
          if (razon !== "") {
            razonText = razon;
            return true;
          } else {
            Swal.showValidationMessage("Debe ingresar una razón");
          }
        },
        allowOutsideClick: () => !Swal.isLoading(),
      }).then((result) => {
        //rechazado
        if (result.isConfirmed) {
          Api.loading(true);
          Api.fetch(
            "app/updateStatusDocPCE",
            {
              id: id,
              estatus: 3,
              razon: razonText,
              subproducto_id: subproducto_id,
            },
            "POST"
          ).then((d) => {
            Api.loading(false);
            this.setState({ documentos: d });
            this.handleBtnPCE();
          });
        }
      });
    } else if (estatus === 2) {
      //aceptado
      Swal.fire({
        title: "¿Seguro que desea aceptar este documento?",
        icon: "question",
        showCancelButton: true,
        confirmButtonText: "Aceptar",
        cancelButtonText: "Regresar",
        reverseButtons: true,
        cancelButtonColor: "Red",
        confirmButtonColor: "#4CD964",
      }).then((result) => {
        if (result.isConfirmed) {
          Api.loading(true);
          Api.fetch(
            "app/updateStatusDocPCE",
            {
              id: id,
              estatus: 4,
              razon: "",
              subproducto_id: subproducto_id,
            },
            "POST"
          ).then((d) => {
            Api.loading(false);
            this.setState({ documentos: d });
            this.handleBtnPCE();
          });
        }
      });
    }
  }

  handleBtnPCE() {
    let detalle = document.querySelector("#SolicitudPCE");
    //let rechazos = 0;
    let sin_verificar = 0;
    let pcedocs = detalle.querySelectorAll(".pce-doc-status");
    for (let pce in pcedocs) {
      if (typeof pcedocs[pce] === "object") {
        if (
          pcedocs[pce].innerText === "Rechazado" //|| pcedocs[pce].innerText === "Sin Verificar"
        ) {
          //rechazos++;
        }

        if (pcedocs[pce].innerText === "Sin Verificar") {
          sin_verificar++;
        }
      }
    }
    /*console.log("***");
    console.log(sin_verificar);
    console.log(this.state.solicitud.documentos.length);
    console.log("**");*/

    if (this.state.solicitud.estatus_tramite_id === 1) {
      detalle.querySelector("#rechazar_pce").classList = "hide";
      detalle.querySelector("#aprobar_pce").classList = "hide";

      //if (rechazos === 0 && sin_verificar <= 0) {
      if (this.state.solicitud.documentos.length === 0) {
        //si no tiene documentos entonces muestrame los dos
        detalle.querySelector("#aprobar_pre").classList = "btn btn-success";
        detalle.querySelector("#rechazar_pre").classList = "btn btn-danger";
      } else if (sin_verificar < 1) {
        detalle.querySelector("#aprobar_pce").classList = "btn btn-success";
      } else {
        detalle.querySelector("#rechazar_pce").classList = "btn btn-danger";
      }

      /* if (sin_verificar > 0) {
        detalle.querySelector("#rechazar_pce").classList = "btn btn-danger";
      } */
    }
  }

  allDocsSol(e) {
    let rChk = [];
    for (let file in this.state.solicitud.documentos) {
      rChk[this.state.solicitud.documentos[file].id] = e.target.checked;
    }

    this.setState({
      solicitudDocsCheck: rChk,
      allSolDocs: e.target.checked,
      allDocs: e.target.checked,
    });
  }

  handlePrevia(e) {
    //let doc = e.target.getAttribute("data-file");
    let id = e.target.getAttribute("data-id");
    let doc = Api.url + `app/vistapreviaPCE/?id=${id}`;
    this.setState({ previa: true, previa_url: doc });
  }

  handlePreviaClose() {
    this.setState({ previa: false });
  }

  handleDownloadZipPCE() {
    let docs = "";
    for (let file in this.state.solicitudDocsCheck) {
      if (this.state.solicitudDocsCheck[file]) {
        docs += file + ",";
      }
    }

    if (docs !== "") {
      this.setState({
        previa_url: Api.url + `app/ZipPCE/?docs=` + docs + "&" + Math.random(),
      });
    }
  }

  handleSolicitudChecks(e) {
    let rChk = [];

    rChk = this.state.solicitudDocsCheck;
    rChk[e.target.id] = e.target.checked;

    this.setState({ solicitudDocsCheck: rChk, allDocs: false });
  }

  handleChangeStatusPCE(e, observacion = "") {
    Api.loading(true);
    let solid = this.state.solicitud.sol_id;

    Api.fetch(
      "app/updateStatusPCE",
      {
        id: solid,
        status: e,
        observacion: observacion,
        observaciones_pce: this.state.solicitud.observaciones,
        informacion: this.state.solicitud,
        leyenda: this.state.solicitud.leyenda,
        lista_marchamos: this.state.lista_marchamos,
      },
      "PUT"
    ).then((r) => {
      Api.notify(r.message);
      if (e === 2) {
        Api.notify(r.message);
      } else {
        this.mi_grid.go(1);
        Api.loading(false);
        this.closeModal();
      }
    });
  }

  handleLeyendaChange(e) {
    let solicitud = { ...this.state.solicitud };
    solicitud.leyenda = e.target.value.toUpperCase();
    this.setState({ solicitud: solicitud });
  }

  handleObservacionChange(e) {
    let solicitud = { ...this.state.solicitud };
    solicitud.observaciones = e.target.value.toUpperCase();
    this.setState({ solicitud: solicitud });
  }

  closeModal() {
    this.setState({
      openModal: false,
      lista_marchamos: [],
    });
    //this.setState({ ...this.initialState });
  }

  resetStates() {
    this.setState({ ...this.initialState });
  }

  closeModalAutorizacion() {
    this.setState({ openModalAutorizacion: false, lista_marchamos: [] });
    //this.setState({ ...this.initialState });
  }

  /**Si se modifica un marchamo cuando su estatus es aceptada habilitara el boton de aceptado */
  addMarchamo(e) {
    let nuevo_marchamo = { numero_marchamo: this.state.no_marchamo };
    let agregar = 1;

    if (nuevo_marchamo.numero_marchamo === "") {
      Swal.fire({
        title: "Atención",
        icon: "warning",
        text: "Favor de ingresar el número de marchamo.",
      });
      agregar = 0;
    }

    if (agregar) {
      let lm = [...this.state.lista_marchamos];

      let exite = this.state.lista_marchamos.find(
        (d) => d.numero_marchamo === nuevo_marchamo.numero_marchamo
      );

      if(exite === undefined){
        lm.push(nuevo_marchamo);
        this.setState({ lista_marchamos: lm, no_marchamo: "" });
      }else{
        Swal.fire({
          title: "Atención",
          icon: "warning",
          text: "Ya cuenta con el marchamo en la lista.",
        });
        return;
      }
    }
    
    if (
      this.state.solicitud.estatus_tramite_id === "5" &&
      e.target.name === "no_marchamo_pce"
    ) {
      let detalle = document.querySelector("#SolicitudPCE");
      detalle.querySelector("#aprobar_pce").classList = "btn btn-success"; //muestra el boton de aceptar

      detalle
        .querySelector("#aprobar_pce")
        .addEventListener("click", this.handlePrecertificadoCEStatus); //y le agrega el evento
    } else if (
      this.state.solicitud_ada.estatus_tramite_id === "5" &&
      e.target.name === "no_marchamo_autorizacion"
    ) {
      let detalle = document.querySelector("#SolicitudADA");
      detalle.querySelector("#aprobar_ada").classList = "btn btn-success";

      detalle
        .querySelector("#aprobar_ada")
        .addEventListener("click", this.handleAutorizacionStatus);
    }
  }

  handleChangeMarchamo(e) {
    this.setState({ no_marchamo: e.target.value });
  }

  removeMarchamo(e) {
    let lista_marchamos = [...this.state.lista_marchamos];
    lista_marchamos.splice(e.target.id, 1);
    this.setState({ lista_marchamos: lista_marchamos });

    //si me modifica el marchamo
    if (
      this.state.solicitud.estatus_tramite_id === "5" ||
      e.target.name === "no_marchamo_pce"
    ) {
      let detalle = document.querySelector("#SolicitudPCE");
      detalle.querySelector("#aprobar_pce").classList = "btn btn-success"; //muestra el boton de aceptar

      detalle
        .querySelector("#aprobar_pce")
        .addEventListener("click", this.handlePrecertificadoCEStatus); //y le agrega el evento
    } else if (
      this.state.solicitud.estatus_tramite_id === "5" ||
      e.target.name === "no_marchamo_autorizacion"
    ) {
      let detalle = document.querySelector("#SolicitudADA");
      detalle.querySelector("#aprobar_ada").classList = "btn btn-success";

      detalle
        .querySelector("#aprobar_ada")
        .addEventListener("click", this.handleAutorizacionStatus);
    }
  }

  handleOpenModalAutorizacion(e) {
    let solicitud_id = this.state.solicitud_id;
    Api.loading(true);
    Api.fetch(
      "app/getSolicitudAutorizacionDA?solicitud_id=" + solicitud_id
    ).then((response) => {
      if (response) {
        response["documentos"] = [];
        this.setState({
          solicitud_ada: response,
          lista_marchamos: response.lista_marchamos,
          tramite_id: response.tramite_id,
          working: false,
          openModalAutorizacion: true,
        });

        let detalle = document.querySelector("#SolicitudADA");
        if (
          this.state.solicitud_ada.estatus_tramite_id === "4" ||
          this.state.solicitud_ada.estatus_tramite_id === "5" ||
          this.state.solicitud_ada.estatus_tramite_id === "10"
        ) {
          detalle.querySelector("#rechazar_ada").classList =
            "btn btn-danger blockea";
          detalle.querySelector("#aprobar_ada").classList =
            "btn btn-success blockea";
        } else {
          detalle
            .querySelector("#rechazar_ada")
            .addEventListener("click", this.handleAutorizacionStatus);
          detalle
            .querySelector("#aprobar_ada")
            .addEventListener("click", this.handleAutorizacionStatus);
        }

        Api.loading(false);
      }
    });
  }

  handleAutorizacionStatus(e) {
    let statusString = {
      Aceptar: 5,
      Rechazar: 4,
    };

    let status = statusString[e.target.innerText];
    let autorizar = 1;

    if (this.state.lista_marchamos.length === 0) {
      Swal.fire({
        title: "Atención",
        icon: "warning",
        text: "Favor de ingresar como mínimo un número de marchamo.",
      });

      autorizar = 0;
    }

    if (status === 5) {
      if (autorizar) {
        Swal.fire({
          title: "¿Aceptar solicitud?",
          text: "Ingrese observaciones si existen.",
          input: "textarea",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Aceptar",
          cancelButtonText: "Regresar",
          cancelButtonColor: "Red",
          confirmButtonColor: "#4CD964",
          reverseButtons: true,
        }).then((result) => {
          if (result.isConfirmed) {
            this.handleChangeStatusADA(e.target.value, result.value);
          }
        });
      }
    } else {
      let razon = "";
      Swal.fire({
        title: "Rechazar solicitud",
        icon: "warning",
        html:
          '<textarea id="swal-input1" placeholder="Ingrese razón del rechazo" class="form' +
          '-control" height="30"></textarea>',
        inputPlaceholder: "Marcar solicitar corrección",
        showCancelButton: true,
        confirmButtonText: "Rechazar",
        cancelButtonText: "Regresar",
        cancelButtonColor: "Red",
        confirmButtonColor: "#4CD964",
        reverseButtons: true,
        preConfirm: (r) => {
          razon = document.querySelector("#swal-input1").value;
          if (razon === "") {
            Swal.showValidationMessage(
              "Es obligatorio ingresar una observación"
            );
          }
        },
      }).then((result) => {
        if (result.isConfirmed) {
          this.handleChangeStatusADA(e.target.value, razon, result.value);
        }
      });
    }
  }

  handleChangeStatusADA(e, observacion = "") {
    Api.loading(true);
    let solid = this.state.solicitud_ada.sol_id;
    

    Api.fetch(
      "app/updateStatusADA",
      {
        id: solid,
        status: e,
        observacion: observacion,
        informacion: this.state.solicitud_ada,
        lista_marchamos: this.state.lista_marchamos,
        medico: true,
      },
      "PUT"
    ).then((data) => {
      Api.loading(false);
      Swal.fire({
        icon: "success",
        title: data.message,
        timer: 3000,
      }).then(() => {
        this.autorizaciones.go(1);
        Api.loading(false);
        this.closeModalAutorizacion();
      });
    }).catch((error) => {
      error.json().then((message) => {
        Api.loading(false);
        Swal.fire({
          title: "Ocurrió un error",
          icon: "error",
          text: message.message,
        });
        this.setState({ procesando: false });
      }); //catching errors to show notification
    }); 
  }

  render() {
    return (
      <div>
        <ol className="breadcrumb float-xl-right">
          <li className="breadcrumb-item">
            {/*<Link to="/form/elements">Home</Link>*/}
            Home
          </li>
          <li className="breadcrumb-item active">Solicitudes</li>
        </ol>
        <h1 className="page-header">Solicitudes</h1>
        <div className="row">
          <div className="col-xl-12">
            <Nav tabs={true}>
              <NavItem>
                <NavLink
                  className={classnames({
                    active: this.state.activeTab === "1",
                  })}
                  onClick={() => {
                    this.toggleTab("1");
                  }}
                >
                  <span className="d-sm-none">
                    Precertificado y/o certificado de exportación
                    {/*  <span className="label label-success m-l-5 t-minus-1">
                    {this.state.registros_pce}
                  </span> */}
                  </span>
                  <span className="d-sm-block d-none">
                    Precertificado y/o certificado de exportación
                    {/* <span className="label label-success m-l-5 t-minus-1">
                    {this.state.registros_pce}
                  </span> */}
                  </span>
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  className={classnames({
                    active: this.state.activeTab === "2",
                  })}
                  onClick={() => {
                    this.toggleTab("2");
                  }}
                >
                  <span className="d-sm-none">
                    Autorización de adquisición
                    {/*  <span className="label label-success m-l-5 t-minus-1">
                    {this.state.registros_ada}
                  </span> */}
                  </span>
                  <span className="d-sm-block d-none">
                    Autorización de adquisición
                    {/* <span className="label label-success m-l-5 t-minus-1">
                    {this.state.registros_ada}
                  </span> */}
                  </span>
                </NavLink>
              </NavItem>
            </Nav>
          </div>
        </div>
        <TabContent activeTab={this.state.activeTab}>
          <TabPane tabId="1">
            <Panel>
              <PanelBody>
                <div className="row">
                  <div className="col-sm-12">
                    <fieldset>
                      <div id="busqueda"></div>
                    </fieldset>
                    <div id="myGrid"></div>
                  </div>
                </div>
              </PanelBody>
            </Panel>
            <div className="hide">
              <fieldset id="cargaDocs"></fieldset>
            </div>
          </TabPane>
          <TabPane tabId="2">
            <Panel>
              <PanelBody>
                <div className="row">
                  <div className="col-sm-12">
                    <fieldset>
                      <div id="busquedaAutorizacion"></div>
                    </fieldset>
                    <div id="myAtorizacion"></div>
                  </div>
                </div>
              </PanelBody>
            </Panel>
          </TabPane>
        </TabContent>
        {/**precertificados */}
        <div>
          <Modal
            isOpen={this.state.openModal}
            tabIndex="-1"
            style={{
              maxWidth: "100%",
              width: "85%",
            }}
          >
            <ModalHeader
              toggle={() => {
                //this.closeModal();
                Swal.fire({
                  title: "¿Seguro que quiere cerrar la solicitud?",
                  showCancelButton: true,
                  confirmButtonText: "Aceptar",
                  cancelButtonText: "Cancelar",
                  reverseButtons: true,
                }).then((result) => {
                  if (result.isConfirmed) {
                    //this.setState({ openModal: false });
                    this.closeModal();
                  }
                });
              }}
              className="text-center"
            >
              Solicitud: {this.state.folio_solicitud}
            </ModalHeader>
            <ModalBody>
              <div /* id="SolicitudPCE" */>
                <ModalSolicitud
                  key={this.state.solicitud_id}
                  component={this}
                  state={this.state}
                />
              </div>
            </ModalBody>
          </Modal>
        </div>
        {/* fin */}
        {/**AUTORIAZCIÓN*/}
        <Modal
          isOpen={this.state.openModalAutorizacion}
          tabIndex="-1"
          style={{
            maxWidth: "100%",
            width: "85%",
          }}
        >
          <ModalHeader
            toggle={() => {
              this.closeModalAutorizacion();
            }}
            className="text-center"
          >
            Solicitud: {this.state.solicitud_ada.folio_solicitud}
          </ModalHeader>
          <ModalBody>
            <ModalSolicitudAutorizacion
              key={this.state.solicitud_ada.solicitud_id}
              component={this}
              state={this.state}
            />
          </ModalBody>
        </Modal>
        {/** FIN */}
      </div>
    );
  }
}

export default (props) => {
  const auth = useAuth();
  const history = useHistory();
  return <Precertificados auth={auth} history={history} {...props} />;
};
